<template>
    <div class="w-full">
      <!-- HERO SECTION -->
      <div class="relative w-full lg:h-[70vh] h-[30vh]">
        <div class="absolute inset-0 overflow-hidden">
          <img
            src="../assets/images/HERO Pages ALL 2.png"
            alt="Background"
            class="w-full h-full object-cover"
          />
          <div class="absolute inset-0 bg-black opacity-50"></div>
        </div>
  
        <div
          class="relative max-w-screen-xl mx-auto h-full flex flex-col items-center justify-center px-6 text-center"
        >
        <h2
          class="text-white text-center text-3xl font-black animate__animated animate__backInLeft"
        >
          Welcome to Lagos Branch
        </h2>
        </div>
  
        <!-- SVG Curve -->
        <svg viewBox="0 0 1440 320" class="absolute bottom-0 left-0 w-full">
          <path
            fill="#ffffff"
            d="M0,224L80,208C160,192,320,160,480,176C640,192,800,256,960,266.7C1120,277,1280,235,1360,213.3L1440,192V320H0Z"
          ></path>
        </svg>
      </div>
  
      <!-- Explore our ultra properties -->
      <section class="py-16 px-6 md:px-10 max-w-screen-xl mx-auto text-gray-900 relative z-10 lg:-mt-32">
       <div class="strategic-card">
           <h3 class="text-3xl font-bold text-start mb-4 text-yellow">Mshel Lagos</h3>
       </div>

       <!-- Different properties cards implementation -->
        <div class="flex align-center justify-center -mt-10">
            <img src="../assets/images/comingsoon.png" alt="" class="object-contain w-50">
        </div>
      </section>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        
      };
    },
    mounted() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("fade-in");
            } else {
              entry.target.classList.remove("fade-in");
            }
          });
        },
        {
          threshold: 0.2, // Adjust for smoother animation trigger
        }
      );
  
      document
        .querySelectorAll(".strategic-card")
        .forEach((card) => observer.observe(card));
    },
  };
  </script>
  
  <style scoped>
  svg path {
    fill: #ffffff !important;
    stroke: none !important;
  }
  
  svg {
    overflow: hidden !important;
  }
  
  .absolute.bottom-0 {
    line-height: 0 !important;
    margin-bottom: -2px;
  }
  
  .strategic-card {
    opacity: 0;
    transform: translateY(50px);
    transition: opacity 1s ease-out, transform 1s ease-out;
    will-change: opacity, transform;
  }
  
  .strategic-card.fade-in {
    opacity: 1;
    transform: translateY(0);
  }
  
  .strategic-card:hover {
    transform: scale(1.03);
    /* box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2); */
    /* transition: transform 0.4s ease-out, box-shadow 0.4s ease-out; */
    /* background-color: inherit !important; */
    box-shadow: none !important;
  }
  </style>
  